'use client';

import { AddToCartButton, AddToCartCounter } from '@/features/product-card/add-to-cart';
import { CartActionPlacement } from '@/features/webengage/types';
import { generateVariantErrorMessage } from '@/app/(pdp)/_utils/generate-variant-error-message';
import { showVariantErrorToast } from '@/app/(pdp)/_utils/show-variant-error-toast';
import { useGetProductInCart } from '@/app/(pdp)/_utils/use-get-product-in-cart';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
const BuyButton = () => {
  const {
    activeVariant,
    hasWeightOptions,
    hasColorOptions,
    hasAtleastOneWeightUnit
  } = useVariantContextValues('baby-pdp');
  const atpId = activeVariant?.id || '';
  const itemProposalId = activeVariant?.itemProposalId || '';
  const limit = activeVariant?.limit || Infinity;
  const {
    productInCart
  } = useGetProductInCart(atpId);
  const countInCart = productInCart?.qty || 0;
  if (countInCart === 0) {
    const errorMessage = generateVariantErrorMessage({
      hasWeightOptions,
      hasColorOptions,
      hasAtleastOneWeightUnit
    });
    return <AddToCartButton itemProposalId={itemProposalId} atpId={atpId} maxLimited={limit} showVariantErrorHandler={() => showVariantErrorToast(errorMessage)} openAlsoBoughtModal={() => {}} className='w-full' type={CartActionPlacement.video} moveScrollToTopOnVariantError={false} />;
  }
  return <AddToCartCounter size='large' atpId={atpId} maxLimited={limit} type={CartActionPlacement.video} className='w-39' data-sentry-element="AddToCartCounter" data-sentry-component="BuyButton" data-sentry-source-file="buy-button.tsx" />;
};
export default BuyButton;